import(/* webpackMode: "eager" */ "/repo/apps/payments-mcp/src/app/global-error.tsx");
